import type { ScoProduct } from '@src/graphql-types'

import { acceleratorPaymentHref } from './controller/checkoutParams'
import { FREE_PLAN_ID } from './planFeatures'
import { productCanContinue } from './presentation'

/** Click fields that decide between the checkout dialog and the payment-page link. */
export type PlanChoiceClick = {
  altKey?: boolean
  button?: number
  ctrlKey?: boolean
  defaultPrevented?: boolean
  metaKey?: boolean
  shiftKey?: boolean
}

/**
 * Unmodified primary click stays on this page. Cmd/ctrl/shift/alt, middle-click, and anything
 * that already cancelled the event follow the payment href (new tab, new window, or no-op).
 */
export function shouldHandlePlanChoiceInPlace(event: PlanChoiceClick): boolean {
  if (event.defaultPrevented) {
    return false
  }
  if (event.button != null && event.button !== 0) {
    return false
  }
  return !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey
}

/** Payment-page href for a plan that can be bought. Free and unpriced plans stay buttons. */
export function planChoiceHref(product?: ScoProduct | null): string | null {
  if (!product || product.productId === FREE_PLAN_ID || !productCanContinue(product)) {
    return null
  }
  return acceleratorPaymentHref(product)
}
